export default __webpack_public_path__ + "static/media/poi_SESUnits.4c135725.svg";